import styled from 'styled-components';

import colors from 'themes/Main';

const { danger } = colors;

export const ErrorMessage = styled.small`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  color: ${danger};
`;
